import theme from '../../../lib/theme';
import { StickyRecirculationProps } from './StickyRecirculation';

const {
  layouts,
  scale,
  layers,
  media,
  colors,
  font: {
    families,
    heights,
    spacings,

    ...font
  },
} = theme;

export default ({ isScrollingUp, collapsed }: StickyRecirculationProps) => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    margin: 0,
    width: '100vw',
    height: collapsed || !isScrollingUp ? 0 : 80,
    overflow: collapsed || !isScrollingUp ? 'hidden' : 'unset',
    opacity: collapsed || !isScrollingUp ? 0 : 1,
    transition: 'all 150ms ease',
    zIndex: layers.high,

    [media.l.up]: {
      display: 'none',
    },
  },

  recirculation: {
    ...layouts.row,

    backgroundColor: colors.light_grey,
    fontFamily: families.primary,
    fontSize: font.xs,
    lineHeight: heights.xs,
    letterSpacing: spacings.m,
    overflowX: 'scroll',
    overflowY: 'hidden',
    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.1)',
    height: '100%',
    padding: scale.xxs,
    WebkitOverflowScrolling: 'touch',

    [media.xs.up]: {
      fontSize: font.s,
      lineHeight: heights.s,
    },

    [media.m.up]: {
      fontSize: font.m,
      lineHeight: heights.m,
    },
  },

  article: {
    ...layouts.row,

    alignItems: 'center',
    borderLeft: `1px solid ${colors.grey}`,
    paddingLeft: scale.xs,
    marginLeft: scale.xs,
    minWidth: '70vw',
    '&:first-child': {
      marginLeft: 0,
      paddingLeft: 0,
      borderLeft: 'none',
    },
  },

  ad: {
    minWidth: '70vw',
    marginRight: '0.8125rem',
  },

  imageLink: {
    height: 50,
  },

  image: {
    objectFit: 'cover',
  },

  title: {
    color: colors.black,
    textDecoration: 'none',
    fontWeight: font.bold,
    transition: 'color 150ms linear',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    '&:hover': {
      color: colors.sas.primary,
    },
  },
});
